import HelloWorld from "./HelloWorld.vue";
import WelcomeBanner from "./WelcomeBanner.vue";
import Dashboard from "./Dashboard.vue";
import SidebarNavigation from "./SidebarNavigation.vue";
import CombinedSidebarNavigation from "./CombinedSidebarNavigation.vue";
import BenchmarkShow from "./benchmark_finder/BenchmarkShow.vue";
import BenchmarkSidebar from "./benchmark_finder/BenchmarkSidebar.vue";
import BenchmarkHome from "./benchmark_finder/BenchmarkHome.vue";
import BenchmarkSelect from "./calculation_wizard/BenchmarkSelect.vue";
import PreviewCalculationSidebar from "./calculation_wizard/preview_step/PreviewCalculationSidebar.vue";
import WageChart from "./calculation_wizard/preview_step/WageChart.vue";
import WageChartVertical from "./calculation_wizard/preview_step/WageChartVertical.vue";
import LivingWageGapCalculationChartDataLoader from "./LivingWageGapCalculationChartDataLoader.vue";
import LivingWageGapCalculationGenderDisparityRowsLoader from "./LivingWageGapCalculationGenderDisparityRowsLoader.vue";
import LivingWageGapCalculationJobCategoryRowsLoader from "./LivingWageGapCalculationJobCategoryRowsLoader.vue";
import ReportGenderDisparityTable from "./ReportGenderDisparityTable.vue";
import ReportJobCategoriesTable from "./ReportJobCategoriesTable.vue";
import WageCalculationsList from "./WageCalculationsList.vue";
import LivingWageCalculationsTable from "./LivingWageCalculationsTable.vue";
import FacilitiesList from "./FacilitiesList.vue";
import FacilityCalculationsTable from "./FacilityCalculationsTable.vue";
import ReportActionsDropdown from "./ReportActionsDropdown.vue";
import ShareReportDropdown from "./ShareReportDropdown.vue";
import ReportJobCategoryGapXlsxButton from "./ReportJobCategoryGapXlsxButton.vue";
import ReportGenderDisparityXlsxButton from "./ReportGenderDisparityXlsxButton.vue";
import GuidedTourModal from "./GuidedTourModal.vue";
import GuidedTourTooltip from "./GuidedTourTooltip.vue";
import HelpInfoModal from "./HelpInfoModal.vue";
import BuyerDashboardLivingWageDonutChart from "./BuyerDashboardLivingWageDonutChart.vue";
import BuyerDashboardGapSizeBarChart from "./BuyerDashboardGapSizeBarChart.vue";
import BuyerDashboardWorkersByCountryBarChart from "./BuyerDashboardWorkersByCountryBarChart.vue";
import BuyerDashboardGenderLwBarChart from "./BuyerDashboardGenderLwBarChart.vue";
import BuyerDashboardRemunerationStackedBarChart from "./BuyerDashboardRemunerationStackedBarChart.vue";
import BuyerDashboardWorkingHoursCountryChart from "./BuyerDashboardWorkingHoursCountryChart.vue";
import DirectoryApp from "./living_directory/DirectoryApp.vue";

// AFT components
import TranslationsProvider from "./aft/TranslationsProvider.vue";
import TranslationForm from "./aft/TranslationForm.vue";
import Translation from "./aft/Translation.vue";
import AftFloatingButton from "./aft/FloatingButton.vue";
import RedactorEditor from "./RedactorEditor.vue";

export const registerComponents = (app) => {
  app.component("HelloWorld", HelloWorld);
  app.component("WelcomeBanner", WelcomeBanner);
  app.component("Dashboard", Dashboard);
  app.component("SidebarNavigation", SidebarNavigation);
  app.component("CombinedSidebarNavigation", CombinedSidebarNavigation);
  app.component("BenchmarkShow", BenchmarkShow);
  app.component("BenchmarkSidebar", BenchmarkSidebar);
  app.component("BenchmarkHome", BenchmarkHome);
  app.component("BenchmarkSelect", BenchmarkSelect);
  app.component("PreviewCalculationSidebar", PreviewCalculationSidebar);
  app.component("WageChart", WageChart);
  app.component("WageChartVertical", WageChartVertical);
  app.component(
    "LivingWageGapCalculationChartDataLoader",
    LivingWageGapCalculationChartDataLoader,
  );
  app.component(
    "LivingWageGapCalculationLoader",
    LivingWageGapCalculationChartDataLoader,
  );
  app.component(
    "LivingWageGapCalculationGenderDisparityRowsLoader",
    LivingWageGapCalculationGenderDisparityRowsLoader,
  );
  app.component(
    "LivingWageGapCalculationJobCategoryRowsLoader",
    LivingWageGapCalculationJobCategoryRowsLoader,
  );
  app.component("DirectoryApp", DirectoryApp);
  app.component("ReportGenderDisparityTable", ReportGenderDisparityTable);
  app.component("ReportJobCategoriesTable", ReportJobCategoriesTable);
  app.component("WageCalculationsList", WageCalculationsList);
  app.component("LivingWageCalculationsTable", LivingWageCalculationsTable);
  app.component("FacilitiesList", FacilitiesList);
  app.component("FacilityCalculationsTable", FacilityCalculationsTable);
  app.component("ReportActionsDropdown", ReportActionsDropdown);
  app.component("ShareReportDropdown", ShareReportDropdown);
  app.component(
    "ReportJobCategoryGapXlsxButton",
    ReportJobCategoryGapXlsxButton,
  );
  app.component(
    "ReportGenderDisparityXlsxButton",
    ReportGenderDisparityXlsxButton,
  );
  app.component("GuidedTourModal", GuidedTourModal);
  app.component("GuidedTourTooltip", GuidedTourTooltip);
  app.component("HelpInfoModal", HelpInfoModal);
  app.component(
    "BuyerDashboardLivingWageDonutChart",
    BuyerDashboardLivingWageDonutChart,
  );
  app.component("BuyerDashboardGapSizeBarChart", BuyerDashboardGapSizeBarChart);
  app.component(
    "BuyerDashboardWorkersByCountryBarChart",
    BuyerDashboardWorkersByCountryBarChart,
  );
  app.component(
    "BuyerDashboardGenderLwBarChart",
    BuyerDashboardGenderLwBarChart,
  );
  app.component(
    "BuyerDashboardRemunerationStackedBarChart",
    BuyerDashboardRemunerationStackedBarChart,
  );
  app.component(
    "BuyerDashboardWorkingHoursCountryChart",
    BuyerDashboardWorkingHoursCountryChart,
  );

  // AFT components
  app.component("TranslationsProvider", TranslationsProvider);
  app.component("TranslationForm", TranslationForm);
  app.component("Translation", Translation);
  app.component("AftFloatingButton", AftFloatingButton);
  app.component("RedactorEditor", RedactorEditor);
};
